<script setup>
import { ErrorMessage, Field, Form } from "vee-validate";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

import TgButton from "@/abc-dsk/components/Button/TgButton.vue";
import TgModal from "@/abc-dsk/components/Modal/TgModal.vue";
import VocabService from "@/common/api/vocab.service";
import NotificationService from "@/common/notification.service";

const props = defineProps({
  shareCode: {
    type: String,
    required: true
  },
  name: {
    type: String,
    required: true
  }
});

const emit = defineEmits(["cancel", "success"]);

const { t } = useI18n();

const listName = ref(props.name);

const onCancel = () => {
  emit("cancel");
};

const onEdit = async () => {
  const name = listName.value;

  try {
    await VocabService.editList(props.shareCode, name);
    NotificationService.success(t("vocab.vocabList.wordListEdit.successToast", { name }));
  } catch (e) {
    NotificationService.error(t("vocab.vocabList.wordListEdit.errorToast"));
  }

  emit("success", name);
};
</script>

<template>
  <TgModal dialog-class="list-edit-modal" body-class="list-edit-modal__body" @close="onCancel()">
    <template #modal-header>
      {{ t("vocab.vocabList.wordListEdit.modalHeading") }}
    </template>
    <div class="row">
      <div class="col-12">
        <Form class="list-edit-form" @submit="onEdit()">
          <div class="d-flex flex-column">
            <Field
              v-model="listName"
              name="input-field"
              class="list-edit-form__input"
              type="text"
              :aria-label="t('vocab.vocabList.wordListEdit.placeholder')"
              :placeholder="t('vocab.vocabList.wordListEdit.placeholder')"
              rules="required|max:50"
            />
            <ErrorMessage name="input-field" class="list-edit-form__input-error" />
          </div>
          <TgButton type="submit">
            {{ t("vocab.vocabList.wordListEdit.buttonText") }}
          </TgButton>
          <TgButton variant="text" color="grey" @click.prevent="onCancel()">
            {{ t("vocab.home.modal.common.cancel") }}
          </TgButton>
        </Form>
      </div>
    </div>
  </TgModal>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

:global(.list-edit-modal) {
  #media-breakpoint-up(sm, {
    max-width: 350px !important;
  });
}

:global(.list-edit-modal__body) {
  padding: 30px 40px;
}

.list-edit-form {
  display: grid;
  row-gap: 25px;

  &__input {
    padding: 10px 12px;
    border: 1px solid rgb(@theme-colors[@grey][50]);
    border-radius: 4px;
    text-align: center;

    &::placeholder {
      color: rgb(@theme-colors[@grey][50]);
    }
  }

  &__input-error {
    margin-top: 5px;
    color: rgb(@theme-colors[@red][base]);
    text-align: center;
  }
}
</style>
